import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../Auth/useAuth";
import Logout from "../Logout/Logout";
import "./DriverNavbar.css";
import logo from "../../Images/logo.jpg";
import axios from "axios";
import config from "../../config";
import Notifications from "../Notifications/Notifications";
import { FaUserCircle } from "react-icons/fa";

const DriverNavbar = () => {
  const { username, userProfile } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Active");
  const [showStatusMessage, setShowStatusMessage] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    // Fetch initial status when component mounts
    const fetchStatus = async () => {
      try {
        const response = await axios.get(
          `${config.BASE_URL}/get-driver-status`,
          {
            params: { username },
            withCredentials: true,
          }
        );
        if (response.data && response.data.status) {
          setStatus(response.data.status);
        }
      } catch (err) {
        console.error("Error fetching status:", err);
      }
    };
    fetchStatus();
  }, [username]);

  const toggleStatus = async (newStatus) => {
    try {
      const response = await axios.post(
        `${config.BASE_URL}/update-driver-status`,
        { Status: newStatus, username },
        { withCredentials: true }
      );
      if (response.status !== 200) {
        throw new Error("Failed to update status");
      }
      setStatus(newStatus);
      setStatusMessage(
        newStatus === "Active" ? "You're online now" : "You're now offline"
      );
      setShowStatusMessage(true);
      setTimeout(() => setShowStatusMessage(false), 3000);
    } catch (err) {
      console.error("Error updating status:", err);
      setStatusMessage("Failed to update status");
      setShowStatusMessage(true);
      setTimeout(() => setShowStatusMessage(false), 3000);
    }
  };

  const handleToggle = () => {
    if (status === "Active") {
      setShowConfirmModal(true);
    } else {
      toggleStatus("Active");
    }
  };

  return (
    <nav className="driver-navbar">
      <div className="navbar-left">
        <img
          src={logo}
          alt="Logo"
          className="logo"
          onClick={() => navigate("/driver")}
          style={{ cursor: "pointer" }}
        />
        {/* <span className='Username-display'>Hello, {username}</span> */}
        <div className="user-profile">
          <div className="menu-toggle">
            {true ? (
              <>
                <FaUserCircle className="profile-icon" />
                <div
                  className="profile-container"
                  onClick={() => navigate("/profile")}
                >
                  <div className="profile-info">
                    <span className="profile-name">
                      {/* {username}, {userProfile.toUpperCase()} */}
                      {username}, {"Driver"}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <FaUserCircle className="profile-icon" />
            )}
          </div>
        </div>
        <div className="route-name-container">
          <div className="route-name">My Trips</div>
        </div>
      </div>
      <div className="nav-buttons-right">
        <div className="circle-toggle" onClick={handleToggle}>
          <div className={`circle-indicator ${status.toLowerCase()}`}></div>
          {status}
        </div>
        {userProfile === "driverAssociate" ? <Notifications /> : ""}
        {showStatusMessage && (
          <div
            className={`status-message ${
              status === "Active" ? "active" : "inactive"
            }`}
          >
            {statusMessage}
          </div>
        )}
        {showConfirmModal && (
          <div className="confirm-overlay">
            <div className="confirm-content">
              <h3>Confirm Logout</h3>
              <p>Are you sure you want to go offline?</p>
              <div className="confirm-actions">
                <button
                  onClick={() => {
                    toggleStatus("Inactive");
                    setShowConfirmModal(false);
                  }}
                >
                  Yes
                </button>
                <button onClick={() => setShowConfirmModal(false)}>No</button>
              </div>
            </div>
          </div>
        )}
        <Logout />
      </div>
    </nav>
  );
};

export default DriverNavbar;
